export default __webpack_public_path__ + "static/media/GC_1.443428fa.png";